/**
 * 端内嵌入路由。
 *
 * 挂在**顶层**，不进 /hsk 的 children —— 这是最关键的一刀：children 会被
 * Layout.vue 包住，而 Layout 隐藏 Header/Footer 的条件是 isMobile && isExamRoute，
 * 其中 isMobile 靠 document.body.getBoundingClientRect().width - 1 < 768
 * （Layout.vue:125），平板和横屏 WebView 上直接失效。
 *
 * 走顶层路由后，Header / Footer / "建议用 Chrome"提示条 / "下载 App"弹窗 /
 * 三套 customized_university 顶栏全部**不被实例化**，零条件判断、零遗漏。
 *
 * 路径里的 v1 是给已发版 app 的冻结契约：app 无法回滚而 web 天天发版，
 * 将来有破坏性改动就开 /embed/v2/，老版本 app 继续吃 v1。
 */

const embedRoutes = [
  {
    path: '/embed/v1/new-hsk/report',
    name: 'EmbedNewHskReport',
    component: () =>
      import(/* webpackChunkName: "group-embed" */ '@/views/hsk/newHskReport/index.vue'),
    meta: {
      needLogin: true,
      // 供路由守卫识别端内页面：embed 模式下只允许在带这个标记的路由之间跳转
      embed: true,
    },
  },
]

export default embedRoutes
